import * as PropertyBucket from '../../Properties/Properties';
import * as httpService from '../../Components/HttpService/HttpService';

export function getBlocksRequested() {
    return {
        type: 'GET_BLOCKS_REQUESTED'
    };
}

export function getBlocksDone(data) {
    return {
        type: 'GET_BLOCKS_DONE',
        payload: data
    };
}

export function getBlocksFailed(error) {
    return {
        type: 'GET_BLOCKS_FAILED',
        payload: error
    };
}

export function getCLBlocksRequested() {
    return {
        type: 'GET_CL_BLOCKS_REQUESTED'
    };
}

export function getCLBlocksDone(data) {
    return {
        type: 'GET_CL_BLOCKS_DONE',
        payload: data
    };
}

export function getCLBlocksFailed(error) {
    return {
        type: 'GET_CL_BLOCKS_FAILED',
        payload: error
    };
}

export function getPickedBlocks(data) {
    return {
        type: 'GET_PICKED_BLOCKS',
        payload: data
    };
}

export function getData() {
    let url = PropertyBucket.getBlocks();
    return dispatch => {
        dispatch(getBlocksRequested());
        let response = httpService.getService(url, "GET");
            response.then(data => {
                data.sort((firstEl, secondEl) => firstEl.blockId - secondEl.blockId);
                 dispatch(getBlocksDone(data));
             })
             .catch(error => {
                 dispatch(getBlocksFailed(error.message));
             })
         }
}

export function getDataPaged(pageSize, pageNumber, filters, sorting, quickSearch) {
    let url = PropertyBucket.getBlocksPaged(pageSize, pageNumber);

    const payload = {quickSearch, filters, sortingField: sorting.index, isDesc: sorting.direction === 'desc' ? true : false};
    return dispatch => {
        dispatch(getBlocksRequested());
        let response = httpService.getServicePromise(url, "POST", payload);
            response.then(data => {
                 dispatch(getBlocksDone(data));
             })
             .catch(error => {
                 dispatch(getBlocksFailed(error.message));
             })
         }
}


export function getTemplateBlocks() {
    let url = PropertyBucket.getBlocks();
    return dispatch => {
        dispatch(getBlocksRequested());
        let response = httpService.getService(url, "GET");
                 response.then(data => {
                     dispatch(getBlocksDone(data));
                 })
                 .catch(error => {
                     dispatch(getBlocksFailed(error));
                 })
         }
}

export function fetchActiveBlocks() {
    let url = PropertyBucket.getActiveBlocks();
    return dispatch => {
        dispatch(getCLBlocksRequested());
        let response = httpService.getService(url, "GET");
                 response.then(data => {
                     dispatch(getCLBlocksDone(data));
                 })
                 .catch(error => {
                     dispatch(getCLBlocksFailed(error));
                 })
         }
}

export function fetchActiveBlocksForQuestions() {
    let url = PropertyBucket.getActiveBlocksForQuestions();
    return dispatch => {
        dispatch(getBlocksRequested());
        let response = httpService.getService(url, "GET");
        response.then(data => {
            dispatch(getBlocksDone(data));
        })
            .catch(error => {
                dispatch(getBlocksFailed(error));
            })
    }
}
export const GET_CL_BLOCKS_REQUESTED = 'GET_CL_BLOCKS_REQUESTED';
export const GET_CL_BLOCKS_DONE = 'GET_CL_BLOCKS_DONE';
export const GET_CL_BLOCKS_FAILED = 'GET_CL_BLOCKS_FAILED';
export const GET_BLOCKS_REQUESTED = 'GET_BLOCKS_REQUESTED';
export const GET_BLOCKS_DONE = 'GET_BLOCKS_DONE';
export const GET_BLOCKS_FAILED = 'GET_BLOCKS_FAILED';
export const GET_PICKED_BLOCKS = 'GET_PICKED_BLOCKS';
